import React from "react";
import type { RootState } from "app/store";
import { useSlc } from "app/store";
import RedirectTo from "components/RedirectTo/RedirectTo";
import { WrapperArticles } from "app/wrappers";

export const PageArticles = () => {
  const isAuth = useSlc((state: RootState) => state.user.isAuth);
  if (isAuth) return <WrapperArticles />;
  return <RedirectTo path="/sign-in" />;
};
